import type {ReactElement} from 'react';
import React from 'react';
import {useSelectedAudioItem} from '@Hooks/poster-editor/useSelectedAudioItem';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';

interface FadeControlsProps {
  className?: string;
}

export function AudioControlsFadeControls({className = ''}: FadeControlsProps): ReactElement | null {
  const selectedAudioItem = useSelectedAudioItem();

  if (!selectedAudioItem) {
    throw new Error('No selected audio item');
  }

  const onFadeInDurationChange = (val: number, undoable: boolean): void => {
    void selectedAudioItem.updateFromObject(
      {
        audioPlayer: {
          fade: {
            fadeInDuration: val,
          },
        },
      },
      {
        undoable,
      }
    );
  };

  const onFadeOutDurationChange = (val: number, undoable: boolean): void => {
    void selectedAudioItem.updateFromObject(
      {
        audioPlayer: {
          fade: {
            fadeOutDuration: val,
          },
        },
      },
      {
        undoable,
      }
    );
  };

  return (
    <div className={`flex-v-row ${className}`}>
      <ContextualMenuSliderOptions
        range={{
          min: 0,
          max: selectedAudioItem.audioPlayer.getMaxFadeDuration(),
        }}
        transformDisplay={{
          min: 0,
          max: selectedAudioItem.audioPlayer.getMaxFadeDuration(),
        }}
        step={0.01}
        value={selectedAudioItem.audioPlayer.fade.fadeInDuration}
        label={window.i18next.t('pmwjs_fade_in')}
        onChange={(val: number) => {
          onFadeInDurationChange(val, false);
        }}
        onChangeEnded={(val: number) => {
          onFadeInDurationChange(val, true);
        }}
        id="fade-in"
      />
      <ContextualMenuSliderOptions
        className="spacing-m-t-3"
        range={{
          min: 0,
          max: selectedAudioItem.audioPlayer.getMaxFadeDuration(),
        }}
        transformDisplay={{
          min: 0,
          max: selectedAudioItem.audioPlayer.getMaxFadeDuration(),
        }}
        step={0.01}
        value={selectedAudioItem.audioPlayer.fade.fadeOutDuration}
        label={window.i18next.t('pmwjs_fade_out')}
        onChange={(val: number) => {
          onFadeOutDurationChange(val, false);
        }}
        onChangeEnded={(val: number) => {
          onFadeOutDurationChange(val, true);
        }}
        id="fade-out"
      />
    </div>
  );
}
